export const getWeekDates = (date: Date): Date[] => {
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  const monday = new Date(date);
  monday.setDate(diff);
  monday.setHours(0, 0, 0, 0);

  const dates: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const currentDate = new Date(monday);
    currentDate.setDate(monday.getDate() + i);
    dates.push(currentDate);
  }

  return dates;
};

export const formatWeekRange = (dates: Date[], locale = "ru-RU"): string => {
  const start = dates[0].toLocaleDateString(locale);
  const end = dates[6].toLocaleDateString(locale);
  return `${start} - ${end}`;
};

export const isCurrentWeek = (dates: Date[]): boolean => {
  const now = new Date();
  const start = new Date(dates[0]);
  start.setHours(0, 0, 0, 0);

  const end = new Date(dates[6]);
  end.setHours(23, 59, 59, 999);

  return now >= start && now <= end;
};

export const shiftWeek = (date: Date, offsetWeeks: number): Date => {
  const next = new Date(date);
  next.setDate(next.getDate() + offsetWeeks * 7);
  return next;
};
